'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AddRecords;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function AddRecords(props) {
  var className = props.className,
      style = props.style;
  return _react2.default.createElement('svg', {
    className: className,
    style: style,
    width: '63px',
    height: '64px',
    viewBox: '0 0 63 64',
    version: '1.1',
    xmlns: 'http://www.w3.org/2000/svg',
    xmlnsXlink: 'http://www.w3.org/1999/xlink'
  }, _react2.default.createElement('g', {
    id: 'Import-File',
    stroke: 'none',
    strokeWidth: '1',
    fill: 'none',
    fillRule: 'evenodd'
  }, _react2.default.createElement('g', {
    id: 'importing-file-1',
    transform: 'translate(-601.000000, -447.000000)',
    fillRule: 'nonzero'
  }, _react2.default.createElement('g', {
    id: 'add-new-record',
    transform: 'translate(601.000000, 447.000000)'
  }, _react2.default.createElement('g', {
    id: 'Group-37'
  }, _react2.default.createElement('path', {
    d: 'M35.6949891,11.8983297 C34.0522877,11.8983297 32.7204067,10.5664489 32.7204067,8.92374728 L32.7204067,0 L5.94916485,0 C2.66303563,0 1.13686838e-13,2.66303563 1.13686838e-13,5.94916485 L1.13686838e-13,53.5424837 C1.13686838e-13,56.8278867 2.66303563,59.4916485 5.94916485,59.4916485 L38.6695715,59.4916485 C41.9549746,59.4916485 44.6187364,56.8278867 44.6187364,53.5424837 L44.6187364,11.8983297 L35.6949891,11.8983297 Z',
    id: 'Path',
    fill: '#E0E0E2'
  }), _react2.default.createElement('path', {
    d: 'M35.6949891,11.8983297 C34.0522877,11.8983297 32.7204067,10.5664489 32.7204067,8.92374728 L32.7204067,0 L5.94916485,0 C2.66303563,0 0,2.66303563 0,5.94916485 L0,53.5424837 C0,56.8278867 2.66303563,59.4916485 5.94916485,59.4916485 L38.6695715,59.4916485 C41.9549746,59.4916485 44.6187364,56.8278867 44.6187364,53.5424837 L44.6187364,11.8983297 L35.6949891,11.8983297 Z',
    id: 'Path',
    fill: '#E3E5ED'
  }), _react2.default.createElement('path', {
    d: 'M35.6949891,11.8983297 L44.6187364,11.8983297 L32.7204067,0 L32.7204067,8.92374728 C32.7204067,10.5664489 34.0522877,11.8983297 35.6949891,11.8983297 Z',
    id: 'Path',
    fill: '#CACAD7'
  }), _react2.default.createElement('path', {
    d: 'M23.7966594,13.3856209 L8.92374728,13.3856209 C8.10239665,13.3856209 7.43645606,12.7196805 7.43645606,11.8983297 C7.43645606,11.0769791 8.10239665,10.4110385 8.92374728,10.4110385 L23.7966594,10.4110385 C24.6180102,10.4110385 25.2839506,11.0769791 25.2839506,11.8983297 C25.2839506,12.7196805 24.6180102,13.3856209 23.7966594,13.3856209 Z',
    id: 'Path',
    fill: '#BFBFCA'
  }), _react2.default.createElement('path', {
    d: 'M35.6949891,22.3093682 L8.92374728,22.3093682 C8.10239665,22.3093682 7.43645606,21.6434278 7.43645606,20.822077 C7.43645606,20.0007264 8.10239665,19.3347858 8.92374728,19.3347858 L35.6949891,19.3347858 C36.5163399,19.3347858 37.1822803,20.0007264 37.1822803,20.822077 C37.1822803,21.6434278 36.5163399,22.3093682 35.6949891,22.3093682 Z',
    id: 'Path',
    fill: '#BFBFCA'
  }), _react2.default.createElement('path', {
    d: 'M35.6949891,31.2331155 L8.92374728,31.2331155 C8.10239665,31.2331155 7.43645606,30.5671751 7.43645606,29.7458243 C7.43645606,28.9244736 8.10239665,28.258533 8.92374728,28.258533 L35.6949891,28.258533 C36.5163399,28.258533 37.1822803,28.9244736 37.1822803,29.7458243 C37.1822803,30.5671751 36.5163399,31.2331155 35.6949891,31.2331155 Z',
    id: 'Path',
    fill: '#BFBFCA'
  }), _react2.default.createElement('path', {
    d: 'M35.6949891,40.1568627 L8.92374728,40.1568627 C8.10239665,40.1568627 7.43645606,39.4909223 7.43645606,38.6695715 C7.43645606,37.8482209 8.10239665,37.1822803 8.92374728,37.1822803 L35.6949891,37.1822803 C36.5163399,37.1822803 37.1822803,37.8482209 37.1822803,38.6695715 C37.1822803,39.4909223 36.5163399,40.1568627 35.6949891,40.1568627 Z',
    id: 'Path',
    fill: '#BFBFCA'
  }), _react2.default.createElement('path', {
    d: 'M32.7204067,49.08061 L8.92374728,49.08061 C8.10239665,49.08061 7.43645606,48.4146696 7.43645606,47.5933188 C7.43645606,46.7719682 8.10239665,46.1060276 8.92374728,46.1060276 L32.7204067,46.1060276 C33.5417575,46.1060276 34.2076979,46.7719682 34.2076979,47.5933188 C34.2076979,48.4146696 33.5417575,49.08061 32.7204067,49.08061 Z',
    id: 'Path',
    fill: '#BFBFCA'
  })), _react2.default.createElement('g', {
    id: 'Group-36',
    transform: 'translate(32.627451, 33.882353)'
  }, _react2.default.createElement('path', {
    d: 'M26.2164314,5.05640895 C24.5260932,3.15028273 22.3779676,1.70682037 19.9744321,0.861346393 C18.3718719,0.288350511 16.6827527,-0.00302414764 14.9808325,4.26325641e-14 C6.70713554,4.26325641e-14 0,6.7071252 0,14.9808222 C-0.00362349011,16.6827423 0.287751169,18.3724711 0.861356738,19.9744217 C2.90829373,25.7842358 8.31274351,29.7403467 14.4687935,29.9366284 C14.6388637,29.9579634 14.8095433,29.9664973 14.9808325,29.9616207 L14.993024,29.9616207 C15.1057944,29.964059 15.218565,29.959792 15.3301163,29.9494293 C21.1569983,29.8159336 26.3779675,26.3151716 28.7132312,20.9747266 C31.0484949,15.6348912 30.0744015,9.42519899 26.2164314,5.05640895 L26.2164314,5.05640895 Z',
    id: 'Path',
    fill: '#2EC4B6'
  }), _react2.default.createElement('path', {
    d: 'M23.5982255,14.0791764 L16.1945206,14.0791764 L16.1945206,6.67547157 C16.1945206,6.09137624 15.7209439,5.61779945 15.1368485,5.61779945 C14.5527532,5.61779945 14.0791764,6.09137624 14.0791764,6.67547157 L14.0791764,14.0791764 L6.67547157,14.0791764 C6.09137624,14.0791764 5.61779945,14.5527532 5.61779945,15.1368485 C5.61779945,15.7209439 6.09137624,16.1945206 6.67547157,16.1945206 L14.0791764,16.1945206 L14.0791764,23.5982255 C14.0791764,24.1823208 14.5527532,24.6558976 15.1368485,24.6558976 C15.7209439,24.6558976 16.1945206,24.1823208 16.1945206,23.5982255 L16.1945206,16.1945206 L23.5982255,16.1945206 C24.1823208,16.1945206 24.6558976,15.7209439 24.6558976,15.1368485 C24.6558976,14.5527532 24.1823208,14.0791764 23.5982255,14.0791764 Z',
    id: 'Path',
    fill: '#FFFFFF'
  }))))));
}

AddRecords.propTypes = {
  style: _propTypes2.default.object,
  className: _propTypes2.default.string
};
AddRecords.defaultProps = {
  style: undefined,
  className: undefined
};